import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import PageTitle from "../components/PageTitle";
import ListHeader from "../../common/components/list-header";
import { borders } from "../../theme/theme";

function AppStatesTable(props: any) {
  const { appStates, setAppStateWorkerProcessLock } = props;
  const columnNames = ["id", "Key", "Value", "Updated at", "Created at"];
  let isWorkerProcessLocked: boolean = false;
  return (
    <div>
      <PageTitle>App States</PageTitle>
      <Box>
        <Paper elevation={0} sx={{ width: "100%", overflowX: "auto", border: `1px solid ${borders.light}`, borderRadius: 2 }}>
          <Table sx={{ minWidth: 700, mb: 5 }}>
            <ListHeader columns={columnNames} />
            <TableBody>
              {((appStates || []) as any[]).map((appState) => {
                if (appState.key === "worker-process-lock") {
                  isWorkerProcessLocked = appState.value;
                }
                return (
                  <TableRow key={appState.id}>
                    <TableCell component="th" scope="row">
                      {appState.id}
                    </TableCell>
                    <TableCell>{appState.key}</TableCell>
                    <TableCell>{appState.value.toString()}</TableCell>
                    <TableCell>{appState.updatedAt}</TableCell>
                    <TableCell>{appState.createdAt}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setAppStateWorkerProcessLock(!isWorkerProcessLocked)}
            sx={{ m: 2 }}
          >
            Toggle Worker Process Lock
          </Button>
        </Paper>
      </Box>
    </div>
  );
}

export default AppStatesTable;
